import { GiHeartInside } from "react-icons/gi";

export const MATERIAL_TEXTURE_MAP = {
    "LABDIA": "DIA",
    "DIA-ST": "DIA",
    "LABDIA-ST": "DIA",
    "DIA-SR": "DIA",
    "STONE-DIA-SR": "STONE-DIA",
    "STONE-LABDIA": "STONE-DIA",
    "STONE-DIA-ST": "STONE-DIA",
    "STONE-LABDIA-ST": "STONE-DIA",
    "10KW": "14KW",
    "10KY": "14KY",
    "14KW": "14KW",
    "14KY": "14KY",
    "14KR": "14KR",
    "18KW": "14KW",
    "18KY": "14KY",
    "18KR": "14KR",
    "22KY": "14KY",
    "SS": "14KW",
    "SILVER": "14KW",
    "CC": "CC",
    "PT": "14KW", 
    "PD": "14KW",
    "Z": "Z",
    "T": "T",
    "TANTALUM": "TA",
    "TANTALUMNOIR": "NTA",
    "TITANIUM": "T",
    "TI": "T",
    "ZIRCONIUM": "Z",
    "D": "D-DAMASCUS",
    "PALL": "CC",
    "PLAT": "14KW",
    "COBALT": "CC",
    "SUPERCONDUCTOR": "SC",
    "SUPERCONDUCTORNOIR": "NSC",
    "MOSAIC-DINOSAURBONEBLACK":"DINOBONE-BLACK",
    "MOSAIC-DINOSAURBONERED":"DINOBONE-RED",
    "MOSAIC-DINOSAURBONETAN":"DINOBONE-TAN",
    "MOSAIC-DINOSAURBONEMIXED":"DINOBONE-MIXED",
    "WMOP":"SHELL-WHITEMOTHEROFPEARL",
    "BMOP":"SHELL-BLACKMOTHEROFPEARL",
    "ABALONE":"SHELL-ABALONE",
    "BASKETWEAVE":"D-BASKETWEAVE",
    "DAMASCUS":"D-DAMASCUS",
    "SUNSET": "D-SUNSET",
    "WOODGRAIN":"D-WOODGRAIN",
    "FLATTWIST":"D-FLATTWIST",
    "TIGHTWEAVE":"D-TIGHTWEAVE",
    "TIGER":"D-TIGER",
    "ZEBRA":"D-ZEBRA",
    "MARBLE":"D-MARBLE",
    "TD": "D-TITANIUM",
    "TITANIUMDAMASCUS": "D-TITANIUM",
    "KINETIC": "D-KINETIC",
    "SCALE": "D-SCALE",
    "FORGEDCF":"CF-FORGED",
    "C-SILVERCF":"CF-SILVER",
    "C-CF": "CF-BLACK",
    "C-FORGEDCF": "CF-FORGED",
    "NUGGET-GOLDNUGGET": "MOSAIC-GOLDNUGGET",
    "HW-DESERTIRONWOOD": "HW-DIW",
    "HW-LEOPARD": "HW-LEOPARDWOOD",
    "KINGS-KINGSDESERT": "CAMO-KCDESERT",
    "KINGS-KINGSFIELD": "CAMO-KCFIELD",
    "KINGS-KINGSMOUNTAIN": "CAMO-KCMOUNTAIN",
    "KINGS-KINGSPINK": "CAMO-KCPINK",
    "KINGS-KINGSSNOW": "CAMO-KCSNOW",
    "KINGS-KINGSWOODLAND": "CAMO-KCWOODLAND",
    "MOSSYOAK-MOCBL": "CAMO-MOBOTTOMLAND",
    "MOSSYOAK-MOCBU": "CAMO-MOBREAKUP",
    "MOSSYOAK-MOCBUI": "CAMO-MOBREAKUPINFINITY",
    "MOSSYOAK-MOCBRUSH": "CAMO-MOBRUSHPATTERN",
    "MOSSYOAK-MOCDB": "CAMO-MODUCKBLIND",
    "MOSSYOAK-MOCOB": "CAMO-MOOBSESSION",
    "MOSSYOAK-MOCPB": "CAMO-MOPINKBOTTOMLAND",
    "MOSSYOAK-MOCPBU": "CAMO-MOPINKBREAKUP",
    "MOSSYOAK-MOCSG":"CAMO-MOSGBLADES",
    "MOSSYOAK-MOCTREESTAND": "CAMO-MOTREESTAND",
    "MOSSYOAK-MOCWINTER": "CAMO-MOWINTERBREAKUP",
    "REALTREE-RTMAX1": "CAMO-RTADVANTAGEMAX~1",
    "REALTREE-RTMAX4": "CAMO-RTADVANTAGEMAX~4",
    "REALTREE-RTAP": "CAMO-RTAP",
    "REALTREE-RTAPBLACK": "CAMO-RTAPCBLACK",
    "REALTREE-RTAPGREEN": "CAMO-RTAPCGREEN",
    "REALTREE-RTAPMAROON": "CAMO-RTAPCMAROON",
    "REALTREE-RTAPORANGE": "CAMO-RTAPCORANGE",
    "REALTREE-RTAPPINK": "CAMO-RTAPCPINK",
    "REALTREE-RTAPPURPLE": "CAMO-RTAPCPURPLE",
    "REALTREE-RTAPRED": "CAMO-RTAPCRED",
    "REALTREE-RTAPSNOW": "CAMO-RTAPCSNOW",
    "REALTREE-RTTIMBER": "CAMO-RTTIMBER",
    "REALTREE-RTAPNAVY": "CAMO-RTAPCNAVYBLUE",
    "REALTREE-RTAPG": "CAMO-RTAPG",
    "KINGSCAMO-KINGSDESERT": "CAMO-KCDESERT",
    "KINGSCAMO-KINGSFIELD": "CAMO-KCFIELD",
    "KINGSCAMO-KINGSMOUNTAIN": "CAMO-KCMOUNTAIN",
    "KINGSCAMO-KINGSPINK": "CAMO-KCPINK",
    "KINGSCAMO-KINGSSNOW": "CAMO-KCSNOW",
    "KINGSCAMO-KINGSWOODLAND": "CAMO-KCWOODLAND",
    "MOSSYOAKCAMO-MOCBL": "CAMO-MOBOTTOMLAND",
    "MOSSYOAKCAMO-MOCBU": "CAMO-MOBREAKUP",
    "MOSSYOAKCAMO-MOCBUI": "CAMO-MOBREAKUPINFINITY",
    "MOSSYOAKCAMO-MOCBRUSH": "CAMO-MOBRUSHPATTERN",
    "MOSSYOAKCAMO-MOCDB": "CAMO-MODUCKBLIND",
    "MOSSYOAKCAMO-MOCOB": "CAMO-MOOBSESSION",
    "MOSSYOAKCAMO-MOCPB": "CAMO-MOPINKBOTTOMLAND",
    "MOSSYOAKCAMO-MOCPBU": "CAMO-MOPINKBREAKUP",
    "MOSSYOAKCAMO-MOCSG":"CAMO-MOSGBLADES",
    "MOSSYOAKCAMO-MOCTREESTAND": "CAMO-MOTREESTAND",
    "MOSSYOAKCAMO-MOCWINTER": "CAMO-MOWINTERBREAKUP",
    "REALTREECAMO-RTMAX1": "CAMO-RTADVANTAGEMAX~1",
    "REALTREECAMO-RTMAX4": "CAMO-RTADVANTAGEMAX~4",
    "REALTREECAMO-RTAP": "CAMO-RTAP",
    "REALTREECAMO-RTAPBLACK": "CAMO-RTAPCBLACK",
    "REALTREECAMO-RTAPGREEN": "CAMO-RTAPCGREEN",
    "REALTREECAMO-RTAPMAROON": "CAMO-RTAPCMAROON",
    "REALTREECAMO-RTAPORANGE": "CAMO-RTAPCORANGE",
    "REALTREECAMO-RTAPPINK": "CAMO-RTAPCPINK",
    "REALTREECAMO-RTAPPURPLE": "CAMO-RTAPCPURPLE",
    "REALTREECAMO-RTAPRED": "CAMO-RTAPCRED",
    "REALTREECAMO-RTAPSNOW": "CAMO-RTAPCSNOW",
    "REALTREECAMO-RTTIMBER": "CAMO-RTTIMBER",
    "REALTREECAMO-RTAPNAVY": "CAMO-RTAPCNAVYBLUE",
    "REALTREECAMO-RTAPG": "CAMO-RTAPG",
    "CERA-SIGPINK": "CER-MAGENTA",
    "CERA-ROBINEGGBLUE": "CER-ROBINSEGGBLUE",
    "CER-MATTEBLACK": "CER-BLACK",
    "CER-MATTEWHITE": "CER-WHITE",
  };


  export const SVG_SIZE = 1200;

  export const PATH_DRAW_REGEX = /<path[^>]*d="([^"]*)"[^>]*>/;

  export const VIEWBOX_REGEX = /viewBox="([^"]+)"/;

  export const IMAGE_LAYER_TYPE = {
    BAND: "band",
    SIGNET: "signet",
    INSIDEBAND: "inside_pattern",
  }